import React from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import ContinueButton from "~components/pages/listing/checkout/continue-button"
import AddAnotherPackageButton from "~components/pages/listing/checkout/add-another-package-button"
import type { QuoteFieldsFragment } from "~graphql/generated/graphql"
import { useIsMobile } from "~components/shared/todo-lib-react-components/hooks/use-is-mobile"
import ContactSupportBanner from "~components/contact-support-banner"

interface Props {
    readonly quote?: QuoteFieldsFragment | null
    readonly noPadding?: boolean
}

export default function CheckoutButtons({ quote, noPadding }: Props) {
    const styles = useStyles({ noPadding })
    const isMobile = useIsMobile()
    const shouldRenderContinue = !isMobile && Boolean(quote)

    return (
        <Box style={styles.root}>
            {/* If we are in mobile view, the button will be rendered in the drawer */}
            {shouldRenderContinue && <ContinueButton />}
            <AddAnotherPackageButton quote={quote} />
            {/* In mobile view the contact button gets rendered on the checkout page instead of the drawer */}
            {isMobile && <ContactSupportBanner />}
        </Box>
    )
}

function useStyles({ noPadding }: { noPadding?: boolean }) {
    const defaultPadding = `0 24px 24px`
    const padding = noPadding ? "0" : defaultPadding

    return componentStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            padding,
            margin: "16px 0",
        },
    })
}
